import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from './services/auth.service';
import { SystemStatusService } from './services/system-status.service';

@Component({
  standalone: false,
  selector: 'app-root',
  template: "<div class=\"app-shell\">\n  <header class=\"app-header\" *ngIf=\"showHeader\">\n    <div class=\"admin-brand\">\n      <a routerLink=\"/\" (click)=\"closeMenu()\" aria-label=\"Home ScipioneCup\">\n        <img src=\"/assets/img/LogoScipioneCup.png\" alt=\"Logo ScipioneCup\" />\n        <h1>ScipioneCup</h1>\n      </a>\n    </div>\n\n    <button type=\"button\" class=\"menu-toggle\" (click)=\"toggleMenu()\" [attr.aria-expanded]=\"menuOpen\" aria-label=\"Apri menu\">\n      <span></span>\n      <span></span>\n      <span></span>\n    </button>\n\n    <nav [class.open]=\"menuOpen\">\n      <a\n        *ngFor=\"let link of currentLinks\"\n        [routerLink]=\"link.path\"\n        routerLinkActive=\"active\"\n        [routerLinkActiveOptions]=\"{ exact: link.exact === true }\"\n        (click)=\"closeMenu()\"\n      >{{ link.label }}</a>\n      <a *ngIf=\"isAdminRoute\" routerLink=\"/\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{ exact: true }\" (click)=\"closeMenu()\">Pubblico</a>\n      <button *ngIf=\"isAdminRoute\" type=\"button\" class=\"header-logout\" (click)=\"logout()\">Esci</button>\n    </nav>\n  </header>\n  <main [class.admin-main]=\"isAdminRoute\">\n    <router-outlet></router-outlet>\n  </main>\n</div>\n",
  styles: [""]
})
export class AppComponent {
  private readonly changeDetector = inject(ChangeDetectorRef);
  private readonly router = inject(Router);
  private readonly authService = new AuthService();
  private readonly systemStatusService = new SystemStatusService();
  private adminAuthCheckId = 0;

  menuOpen = false;
  publicOffline = true;
  isAdminAuthenticated = false;

  readonly publicLinks = [
    { label: 'Home', path: '/', exact: true },
    { label: 'Gironi', path: '/gironi' },
    { label: 'Calendario', path: '/calendario' },
    { label: 'Classifiche', path: '/classifiche' },
    { label: 'Fase finale', path: '/fase-finale' },
    { label: 'Squadre', path: '/squadre' },
    { label: 'News', path: '/news' }
  ];

  readonly adminLinks = [
    { label: 'Squadre', path: '/admin/squadre' },
    { label: 'Giocatori', path: '/admin/giocatori' },
    { label: 'Gironi', path: '/admin/gironi' },
    { label: 'Calendario', path: '/admin/calendario' },
    { label: 'Live', path: '/admin/live' },
    { label: 'News', path: '/admin/news' },
    { label: 'Classifiche', path: '/admin/classifiche' },
    { label: 'Fase finale', path: '/admin/fase-finale' },
    { label: 'Operazioni', path: '/admin/operazioni' }
  ];

  get isAdminRoute(): boolean {
    return window.location.pathname.startsWith('/admin');
  }

  get isLoginRoute(): boolean {
    return window.location.pathname.startsWith('/login');
  }

  get showHeader(): boolean {
    if (this.isLoginRoute) {
      return false;
    }

    if (this.isAdminRoute) {
      return this.isAdminAuthenticated;
    }

    return !this.publicOffline;
  }

  get currentLinks(): { label: string; path: string; exact?: boolean }[] {
    return this.isAdminRoute && this.isAdminAuthenticated ? this.adminLinks : this.publicLinks;
  }

  ngOnInit(): void {
    this.refreshPublicStatus();
    this.refreshAdminAuthState();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.menuOpen = false;
        this.refreshAdminAuthState();
        this.changeDetector.detectChanges();
      }
    });
  }

  async refreshPublicStatus(): Promise<void> {
    try {
      const status = await this.systemStatusService.get();
      this.publicOffline = Boolean(status.public_offline);
      if (this.publicOffline && !this.isAdminRoute) {
        this.menuOpen = false;
      }
      this.changeDetector.detectChanges();
    } catch (_error) {
      this.publicOffline = false;
      this.changeDetector.detectChanges();
    }
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu(): void {
    this.menuOpen = false;
  }

  async refreshAdminAuthState(): Promise<void> {
    const checkId = ++this.adminAuthCheckId;

    if (!this.isAdminRoute) {
      this.isAdminAuthenticated = false;
      this.changeDetector.detectChanges();
      return;
    }

    try {
      const state = await this.authService.me();
      if (checkId === this.adminAuthCheckId) {
        this.isAdminAuthenticated = state.authenticated;
        this.changeDetector.detectChanges();
      }
    } catch (_error) {
      if (checkId === this.adminAuthCheckId) {
        this.isAdminAuthenticated = false;
        this.menuOpen = false;
        this.changeDetector.detectChanges();
      }
    }
  }

  async logout(): Promise<void> {
    await this.authService.logout();
    this.isAdminAuthenticated = false;
    window.location.href = '/login';
  }
}
